module.exports = {
  footerText: 'Developed by: Studio Media Agency 2019',
};
